var map = {
	"./duma1.jpg": 5717,
	"./duma2.jpg": 2461,
	"./duma3.jpg": 6407,
	"assets/collections/editorials/Magazyn DUMA/duma1.jpg": 5717,
	"assets/collections/editorials/Magazyn DUMA/duma2.jpg": 2461,
	"assets/collections/editorials/Magazyn DUMA/duma3.jpg": 6407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2054;